(function() {
  'use strict';
  
  console.log('Variant display script loaded');
  
  function updateVariantName() {
    // Find all variant option inputs (radio buttons or selects)
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) {
      console.log('No form found');
      return;
    }
    
    // Get all selected option values
    const options = [];
    const selects = form.querySelectorAll('select[name^="option"]');
    const radios = form.querySelectorAll('input[type="radio"][name^="option"]:checked');
    
    // Collect from selects
    selects.forEach(select => {
      if (select.value) options.push(select.value);
    });
    
    // Collect from radio buttons
    radios.forEach(radio => {
      if (radio.value) options.push(radio.value);
    });
    
    console.log('Selected options:', options);
    
    // Update the display
    const displayEl = document.querySelector('.selected-variant-display');
    if (displayEl && options.length > 0) {
      displayEl.textContent = options.join(' - ').toUpperCase();
      console.log('Updated to:', options.join(' - ').toUpperCase());
    }
  }
  
  // Run on page load
  document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM loaded');
    updateVariantName();
    
    // Listen for any clicks on the page (catches swatch clicks)
    document.addEventListener('click', function(e) {
      // Small delay to let the form update
      setTimeout(updateVariantName, 50);
    });
    
    // Listen for form changes
    const form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      form.addEventListener('change', updateVariantName);
    }
  });
})();
